import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=f9ab14da"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=f9ab14da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports